module.exports = __webpack_public_path__ + "static/media/logo.41ba383b.png";